/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _map from 'lodash/map';
import _isString from 'lodash/isString';
import { __spreadArray } from 'tslib';

/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2018-08-23 11:24:04
 * @modify date 2018-08-23 11:24:04
 * @desc [输出日志]
 */

var Log =
/** @class */
function () {
  function Log() {}

  Log.log = function (optiona) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    try {
      optiona = _isString(optiona) ? {
        message: optiona,
        color: Log.color.info
      } : optiona;

      if (console && console.log) {
        console.log(' ');
        Log.group ? console === null || console === void 0 ? void 0 : console.groupCollapsed("%c -- " + optiona.message + " --", "color:" + optiona.color) : console.log("%c -- " + optiona.message + " --", "color:" + optiona.color);

        _map(optionalParams, function (item) {
          return console.log(item);
        });

        if (process.env.APP_ENV !== 'release') {
          console === null || console === void 0 ? void 0 : console.groupCollapsed("%c -- [\u5806\u6808\u8BB0\u5F55] --", "color:" + Log.color.error);
          console === null || console === void 0 ? void 0 : console.trace(); // hidden in collapsed group
        }

        console === null || console === void 0 ? void 0 : console.groupEnd();
        console === null || console === void 0 ? void 0 : console.groupEnd();
        console.log(' ');
      }
    } catch (error) {
      console.error("LENG ~ Log ~ error", error);
    }
  };

  Log.info = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    Log.log.apply(Log, __spreadArray([{
      message: message,
      color: Log.color.info
    }], optionalParams));
  };

  Log.error = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    Log.log.apply(Log, __spreadArray([{
      message: message,
      color: Log.color.error
    }], optionalParams));
  };

  Log.success = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    Log.log.apply(Log, __spreadArray([{
      message: message,
      color: Log.color.success
    }], optionalParams));
  };

  Log.warning = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    Log.log.apply(Log, __spreadArray([{
      message: message,
      color: Log.color.warning
    }], optionalParams));
  };

  Log.group = true; // https://ant.design/docs/spec/colors-cn

  Log.color = {
    info: '#1890ff',
    error: '#f5222d',
    success: '#52c41a',
    warning: '#fadb14'
  };
  return Log;
}();

export { Log };
//# sourceMappingURL=log.js.map
